import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges, Optional, Inject } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output, OnChanges } from '@angular/core';
import { consts } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { UntypedFormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { InvestmentPropertyModel, InvestmentPropertyTaxesModel } from './investment-property.model';
import { Utils } from '../../../shared/utils';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service'; import { Router } from '@angular/router';
import { InvestmentPropertyService } from './investment-property.service';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../shared/services/shared.service';
import { InvestmentPropertyDialogImportAccount } from './investmentProperty-dialog-importAccount.component';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { map } from 'rxjs/operators';

@Component({
    selector: 'convfact-investment-property-form',
    templateUrl: './investment-property-form.component.html',
    styleUrls: ['./investment-property.component.css'],
    standalone: false
})
export class InvestmentPropertyFormComponent implements OnInit, OnChanges {

  @Input() investmentProperty: InvestmentPropertyModel;
  @Input() accounts: AccountingAccountsModel[] = [];
  @Output() onSave = new EventEmitter<any>();

  public originEntity: string = consts.INVESTMENT_ENTITY;
  public filePath: string = consts.INVESTMENT_FILE_PATH;

  public loading = false;
  public ready = false;

  public imageTempUrl: any = '';

  public readyLoadedFiles: boolean = null;

  public taxes = Array<InvestmentPropertyTaxesModel>();

  public contactCtrl: UntypedFormControl;
  public filteredContacts: Observable<ContactModel[]>;
  public contactList: ContactModel[] = [];

  public newContactLoaded = new BehaviorSubject<boolean>(true);

  constructor(
    private contactService: ContactService,
    private preinvoiceService: PreinvoiceService, // Only for obtain taxes
    private addFileService: AddFileService,
    public snackBar: MatSnackBar,
    private ref: ChangeDetectorRef,
    public router: Router,
    private investmentPropertyService: InvestmentPropertyService,
    private accountingAccountsService: AccountingAccountsService,
    public dialog: MatDialog,

    private sharedService: SharedService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRefImport: MatDialogRef<AccountingMovementsImportComponent>,
    @Optional() public dialogRef: MatDialogRef<InvestmentPropertyFormComponent>
  ) { }

  //AccountMovementes Import data
  flagImport: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  saved: boolean = false;
  //-----------------------------

  public ngOnInit(): void {
    this.ready = false;

    if (this.data != null) {

      this.accountingAccountsService.getListInvestmentsPropertyAccounts()
        .then(data => this.accounts = data);

      this.flagImport = this.data.flagImport;
      this.movement = this.data.movement;
      this.type = this.data.type;
      this.movement.type = this.type;
      this.investmentProperty.manualMovement = this.movement;

      this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
        this.investmentProperty.manualMovement.accountNumber = response;
        this.investmentProperty.accountingModelsNumber = response;
      })

      this.investmentProperty.base = this.movement.amount;
      this.investmentProperty.investmentDate = this.movement.date;
    }

    this.contactList = [];
    this.contactService.getListProviders().then(response => {
      this.contactList = response;
    }).catch(err => {
      this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
    });

    this.contactCtrl = new UntypedFormControl();
    this.filteredContacts = this.contactCtrl.valueChanges
      .pipe(
        map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
        map(name => this.filterContacts(name))
      );

    // Impuestos -> los obtenemos de el mismo servicio para evitar hacer duplicados
    this.preinvoiceService.accountsAndTaxesData()
      .then(accountsAndTaxes => {
        this.ready = true;
        this.taxes = accountsAndTaxes.taxes;
      });

    this.ready = true;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.investmentProperty && changes.investmentProperty.currentValue.isPdf != undefined) {
      if (this.investmentProperty.isPdf) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFilesPDF(this.investmentProperty.filesInvestmentUid, this.originEntity).then(result => {
          this.loadPdfBlob(result);
          this.readyLoadedFiles = true;
        });
      }
    }
    if (changes.investmentProperty && changes.investmentProperty.currentValue.isImage != undefined) {
      if (this.investmentProperty.isImage) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFiles(this.investmentProperty.filesInvestmentUid, this.originEntity).then(response => {
          this.createImageFromBlob(response);
          this.readyLoadedFiles = true;
        })
      }
    }
  }

  public filterContacts(val) {
    for (const contact of this.contactList) {
      if (contact.companyName == val && contact.isProvider) {
        this.investmentProperty.contactsUid = contact.uid;
        this.investmentProperty.contactsName = contact.companyName;
      }
    }

    return val ? this.contactList.filter(s => s.companyName != null && s.companyName.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.contactList;
  }

  public save(): void {
    this.loading = true;
    let noError = true;

    if (this.investmentProperty.accountingModelsId == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("Es necesario seleccionar una de las opciones del campo 'Tipo inversion'");
    }

    if (this.investmentProperty.contactsUid == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("Es necesario seleccionar una de las opciones del campo 'Proveedor'");
    }

    if (this.investmentProperty.investmentDate == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'fecha de inversión' es requerido");
    }

    if (this.investmentProperty.investmentDescription == null || this.investmentProperty.investmentDescription == '') {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Descripción' es requerido");
    }

    if (this.investmentProperty.usage == null || this.investmentProperty.usage === 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Uso' es requerido");
    }

    if (this.investmentProperty.base == null) {
      noError = false;
      this.loading = false;
      this.displayInfo("El campo 'Total (Sin impuestos)' es requerido");
    }

    if (this.investmentProperty.base <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El valor de 'Total (Sin impuestos)' no puede ser menor o igual a 0");
    }

    this.setDefaultsValues();

    if (noError) {
      if (this.data !== null) {
        if (this.data.movement !== null) {
          this.saveData(this.investmentProperty);
          this.loading = false;
        }
      } else {
        this.onSave.emit(this.investmentProperty);
        this.loading = false;
      }

    }
  }

  public saveData(investmentProperty: InvestmentPropertyModel): void {

    if (investmentProperty.uid == null) {
      this.investmentPropertyService.add(investmentProperty)
        .then(response => {
          if (this.data != null) { this.saved = true; }
        },
          error => {
            //Si venimos de importar, y ya existe la inversión, preguntamos si queremos actualizar
            //la inversión ya existente
            if (error.error['message'].includes("ya se encuentra registrada") && this.data != null) {
              const dialogRef = this.dialog.open(InvestmentPropertyDialogImportAccount, {
                // width: '20%',
                //height: '40%',
                data: {
                  dataImport: investmentProperty,
                }
              }).afterClosed().subscribe(result => this.closeDialog())
            } else {
              this.displayInfo(error.error['message']);
            }
          });
    } else {
      this.investmentPropertyService.edit(investmentProperty)
        .then(response => {
          this.returnToIndex();
        })
        .catch(error => {
          this.displayError("Ha ocurrido un error inesperado al actualizar la inversion")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['investment/property']);
  }

  public createImageFromBlob(image: Blob): void {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  public loadPdfBlob(data: Blob): void {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  public SetFileParameters(event): void {
    this.imageTempUrl = null;
    this.investmentProperty.isImage = event.Image;
    this.investmentProperty.isPdf = event.PDF;
    this.investmentProperty.filesInvestmentUid = event.FileUid;

    if (event.File) {
      this.createImageFromBlob(event.File);
    }

    if (event.PDF) {
      this.loadPdfBlob(event.File);
    }
  }

  public setDefaultsValues(): void {
  }

  public changeToggleCompanyPremisesOrOffice(event: MatSlideToggleChange) {
    if (event.checked) {
      this.investmentProperty.companyPremisesOrOffice = true;
    } else {
      this.investmentProperty.companyPremisesOrOffice = false;
    }
  }

  public checkImage(): void {
    if (this.investmentProperty.filesInvestmentUid != null || this.investmentProperty.isImage || this.investmentProperty.isPdf) {
      this.addFileService.getImageFromFiles(this.investmentProperty.filesInvestmentUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
      })
    }
  }

  public setUsageOption(value: number) {
    this.investmentProperty.usage = value;
  }

  public setTax(tax: InvestmentPropertyTaxesModel): void {
    // Al entrar algunas veces este valor era null
    if (this.investmentProperty.taxes == null) {
      this.investmentProperty.taxes = new Array<InvestmentPropertyTaxesModel>();
    }

    this.investmentProperty.taxes.push(tax);
  }

  onSelectTax(data: any) {
    this.setTax(this.taxes.filter(c => c.id == data)[0])
  }

  public changeChips(): void {
    // No hace nada
  }

  public calcularTotal(): number {
    const investmentBase: number = this.investmentProperty.base == null ? 0 : this.investmentProperty.base;

    let total: number = Number(investmentBase);

    if (this.investmentProperty.taxes != undefined) {
      this.investmentProperty.taxes.forEach(tax => {
        let aux: number = (tax.taxImport / 100) * this.investmentProperty.base;
        total += aux;
        aux = 0;
      });
    }

    return Utils.GetValueWithDecimals(total);
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  closeDialog() {
    this.dialogRefImport.close(this.saved);
  }

  public change(value: string) {
    const accountNumber = this.accounts.find(x => x.number === value);

    this.investmentProperty.accountingModelsId = Number(accountNumber.id);
  }

  public newContact(isExpense: boolean): void {
    const contactScratch = new ContactModel();

    if (isExpense) {
      contactScratch.isProvider = true;
      contactScratch.isClient = false;
    } else {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        })
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListProviders().then(response => {
            if (response.length === this.contactList.length) {
              this.contactList = response;
              this.newContactLoaded.next(null);
            } else {
              this.contactList = response;
              this.newContactLoaded.next(true);
            }
          }).catch(() => {
            this.newContactLoaded.next(true);
            this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
          });
        }
      });
  }

  public trackByIndex(i: number) { return i; }

}
